var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup125(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(-63 -307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    transform: "translate(63 307)",
    fill: "none",
    stroke: "#7f7f7f",
    strokeWidth: 5,
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5,
    cy: 12,
    rx: 12.5,
    ry: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5,
    cy: 12,
    rx: 10,
    ry: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    transform: "translate(76 307)",
    fill: "none",
    stroke: "#7f7f7f",
    strokeWidth: 5,
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5,
    cy: 12,
    rx: 12.5,
    ry: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5,
    cy: 12,
    rx: 10,
    ry: 9.5,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup125);
export default __webpack_public_path__ + "static/media/Group 125.5f62a954046146da4127184187ab59af.svg";
export { ForwardRef as ReactComponent };